import bemCx from 'bem-modifiers'

import { scrollTo } from '~/utils/helpers'

export default ({ faqObject, offset, activeNavId }) => {
  const categories = Object.keys(faqObject)

  return (
    <ul className='faq-nav'>
      {categories.map((category, index) => (
        <li
          className={bemCx('faq-nav__item', { 'active': activeNavId === category })}
          key={index}
          id={`nav-${category}`}
        >
          <a
            className='faq-nav__link'
            href={`#${category}`}
            dangerouslySetInnerHTML={{ __html: faqObject[category].heading }}
            onClick={scrollTo(category, { duration: 350, offset: offset })}
          />
        </li>
      ))}
    </ul>
  )
}
